import React from "react";

import { ButtonContainer, ButtonLabel, ButtonLinkContainer } from "./styles";

import { ButtonProps } from "./types";

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      hideBorder,
      label,
      labelStyle = {},
      size = "small",
      color = "dark",
      variant = "outline",
      before,
      after,
      style,
      children,
      ...props
    }: ButtonProps,
    ref,
  ) => {
    return (
      <ButtonContainer
        ref={ref}
        size={size}
        hideBorder={hideBorder}
        color={color}
        variant={variant}
        style={style}
        {...props}
        disabled={props.disabled || props.loading}
      >
        {!!before && before}
        {!!(label || children) && (
          <ButtonLabel style={{ ...labelStyle }}>
            {label || children}
          </ButtonLabel>
        )}
        {!!after && after}
      </ButtonContainer>
    );
  },
);
Button.displayName = "Button";

export const ButtonLink = React.forwardRef<HTMLAnchorElement, ButtonProps>(
  (
    {
      hideBorder,
      label,
      labelStyle = {},
      size = "small",
      color = "dark",
      variant = "outline",
      before,
      after,
      style,
      children,
      href,
      locale,
      ...props
    }: ButtonProps,
    ref,
  ) => {
    if (!href) {
      console.warn("ButtonLink href is undefined or null", { href, locale, label, children} );
    }
    return (
      <ButtonLinkContainer
        ref={ref}
        size={size}
        hideBorder={hideBorder}
        color={color}
        variant={variant}
        style={style}
        href={href as any || '#'}
        locale={locale as any}
        {...props}
      >
        {!!before && before}
        {!!(label || children) && (
          <ButtonLabel style={{ ...labelStyle }}>
            {label || children}
          </ButtonLabel>
        )}
        {!!after && after}
      </ButtonLinkContainer>
    );
  },
);
ButtonLink.displayName = "ButtonLink";
